import React from 'react';

import SecurityPageContent
  from 'components/dashboard/security-content/SecurityPageContent';

const DashboardSecurityPage = () => <SecurityPageContent />;

export default DashboardSecurityPage;
